import { useQuery } from '@tanstack/react-query';

import { fetchPrescriptionLogs } from '../api/getPrescriptionLogs.js';
import { rxKeys } from './keys.js';

export function prescriptionLogsQueryDefinition(userId: string, dosespotPrescriptionId: string) {
  return {
    queryKey: rxKeys.prescriptionLogs(userId, dosespotPrescriptionId),
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      fetchPrescriptionLogs(userId, dosespotPrescriptionId, signal),
    meta: {
      toast: {
        title: 'Could not load prescription logs',
        description: 'Prescription logs could not be fetched from DoseSpot.',
      },
    },
  } as const;
}

export function usePrescriptionLogsQuery(
  userId: string | undefined,
  dosespotPrescriptionId: string
) {
  return useQuery({
    ...prescriptionLogsQueryDefinition(userId ?? '', dosespotPrescriptionId),
    enabled: !!userId && dosespotPrescriptionId.trim() !== '',
  });
}
